<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'政策指引管理'},{name:'政策资讯列表',goback:true},{name:'政策资讯明细'}]" :title="'政策资讯明细'"/>
            <!-- 详情 -->
            <div class="box">
            <el-card class="basic box_card" header="基础信息" shadow="never">
              <el-row>
                <el-col :span="8">
                  <div class="child">
                        <div class="name">政策资讯标题：</div>
                        <div class="content">{{messageInfo.title}}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="child">
                        <div class="name">适用行业：</div>
                        <div class="content" v-if="messageInfo.industry&&messageInfo.industry.length>0">
						<!-- {{messageInfo.industry}} -->
						<span v-for="(i,index) in messageInfo.industry" :key="index">{{i.value}} </span>
						</div>
                    </div>
                </el-col>
                <el-col :span="8">
                  <div class="child">
                        <div class="name">适用地区：</div>
                        <div class="content">{{ messageInfo.provinceValue+messageInfo.cityValue+messageInfo.areaValue}}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                  <div class="child">
                        <div class="name">来源：</div>
                        <div class="content">{{messageInfo.source}}</div>
                    </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                    <div class="child">
                        <div class="name">资讯详情：</div>
                        <ul class="content">
                            <li v-for=" (item,i) in messageInfo.guidelinesDetails" :key="i">
                                <div v-if="item.type == 'text'" style="word-wrap:break-word;width: 1200px;" class="super_p" v-html="item.content"></div>
                                <img v-if="item.type == 'url'" style="max-width:400px" :src="messageInfo.frontPath+item.content" />
                            </li>   
                        </ul>
                    </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                    <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in messageInfo.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                            <!-- <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li>
                            <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li>
                            <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li> -->
                        </ul>
                    </div>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="basic box_card mt16" header="其它信息" shadow="never">
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{messageInfo.createUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{messageInfo.createTime}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">更新账号：</div>
                        <div class="content">{{messageInfo.modifyUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{messageInfo.updateTime}}</div>
                    </div>
                  </el-col>
                </el-row>
            </el-card>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import timeMixins from "@/mixins/timeFormat";
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        breadcrumb
    },
    data(){
        return{
            messageInfo:{}
        }
    },
    methods:{
        //下载附件
         downLoad:function({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
       },
    },
    mounted(){
        let id = this.$route.query.id
        this.$axiosc.get('backstage/policy/guidelines/details/'+id).then(res=>{
            if(res.code == 200){
                this.messageInfo = res.data
                if(this.messageInfo.fileList.length > 0){
                    if(!this.messageInfo.fileList[0].frontPath){
                        let value = []
                        this.messageInfo.fileList.map(val=>{
                            value.push({fileName:val.fileName,filePath:val.filePath,frontPath:this.messageInfo.frontPath})
                        })
                        this.messageInfo.fileList = value
                    }
                }
            }else{
                this.$alert(res.msg)
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    overflow: hidden;
    .box{
        // padding-top: 20px;
        height:calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
.main {
  background: transparent !important;
  padding: 0 !important;
}
</style>